var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex, Icon, Text } from 'shared/components';
import { Info } from 'shared/assets/icons';
import { useWatch } from 'react-hook-form';
export var IssueCaution = function () {
    var reason = useWatch({ name: 'issueReason' });
    if (!reason) {
        return _jsx(_Fragment, {});
    }
    else {
        return (_jsx(Box, __assign({ backgroundColor: "warning.light", color: "warning.onLight", padding: 4, rounded: "2xl" }, { children: _jsxs(Flex, __assign({ flexDir: "row" }, { children: [_jsx(Icon, { as: Info, mr: 3, boxSize: 4 }), _jsx(Flex, __assign({ flexDir: "row" }, { children: _jsx(Text, __assign({ "data-testid": "warningMessage", size: "body2" }, { children: "Have you confirmed that this appointment is accurately reflected in acuity? If applicable, mark this appointment as complimentary in Admin." })) }))] })) })));
    }
};
